import React from "react";
import Tree from "venuescanner-js/react/components/Objects/Icons/svgs/tree.svg";

export const IconTree = () => (
  <img src={Tree} aria-hidden="true" focusable="false" />
);

export default IconTree;
